import $ from 'jquery';

export default class UserEditChannels {
  init() {
    const form = $('#edit-form--channels');

    if (form.length) {
      $(window).on('scroll', () => {
        const scrollTop = $(window).scrollTop();
        const form_offset = form.offset();
        const form_height = form.height();

        if (scrollTop > (form_offset.top + (form_height / 2))) {
          form.attr('hx-target', '#edit-form--channels-response-lower');
          form.attr('hx-indicator', '#edit-form--channels-loader-lower');
        } else {
          form.attr('hx-target', '#edit-form--channels-response-upper');
          form.attr('hx-indicator', '#edit-form--channels-loader-upper');
        }
      });
    }

    // Check all children if parent is checked
    const setCheck = (elm, checked) => {
      const input = $(elm);
      if (checked) {
        input.prop('checked', true).attr('checked', 'checked');
      } else {
        input.prop('checked', false).removeAttr('checked');
      }
    };

    const checkboxSelector = '.page-template-template-account .acf-field-5ffa3fa880cca ul.acf-checkbox-list > li > label';
    $(checkboxSelector).on('change', 'input[type="checkbox"]', evn => {
      const self = $(evn.currentTarget);
      const checked = self.is(':checked');

      if (self.val() === 'all') {
        self
          .parents('.acf-field-5ffa3fa880cca')
          .siblings('.acf-fields')
          .find('input[type="checkbox"]')
          .each((idx, elm) => setCheck(elm, checked));
      } else {
        const children = self.parents('label').siblings('ul.children');
        children.find('input[type="checkbox"]').each((idx, elm) => setCheck(elm, checked));
      }
    });
  }
}
